import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Textarea } from '@/components/ui/textarea'
import { MarkdownRenderer } from './markdown-renderer'

const TEXTAREA_CLASS = 'rounded-lg bg-background text-sm shadow-sm border border-border'

type MarkdownEditorProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  rows?: number
}

// Write/preview toggle over a Markdown textarea. Takes a controlled value/onChange rather than
// a react-hook-form field directly, so callers wire it up via form.watch/form.setValue.
export const MarkdownEditor = ({ value, onChange, placeholder, rows = 3 }: MarkdownEditorProps) => {
  const [mode, setMode] = useState<'write' | 'preview'>('write')

  return (
    <div className="flex flex-col gap-2">
      <Tabs value={mode} onValueChange={(next) => setMode(next as 'write' | 'preview')}>
        <TabsList className="h-8 w-fit">
          <TabsTrigger value="write" className="text-xs px-3 py-1">
            Write
          </TabsTrigger>
          <TabsTrigger value="preview" className="text-xs px-3 py-1">
            Preview
          </TabsTrigger>
        </TabsList>
      </Tabs>

      {mode === 'write' ? (
        <Textarea
          rows={rows}
          placeholder={placeholder}
          className={TEXTAREA_CLASS}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <div className="min-h-[3rem] rounded-lg border border-border bg-background p-3">
          {value ? (
            <MarkdownRenderer markdown={value} />
          ) : (
            <p className="text-sm text-muted-foreground">Nothing to preview.</p>
          )}
        </div>
      )}
    </div>
  )
}
